// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__WjfsC","title":"ClientCherryInfo_title__1AiA7","itemText":"ClientCherryInfo_itemText__2FpDU"};